
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/dresses",
      function () {
        return require("private-next-pages/apparel/dresses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/dresses"])
      });
    }
  